import React from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Paper, Typography } from '@mui/material';
import { INK, MUTED, RULE } from '../analytics/analyticsUi';

// Rendered by the catch-all route outside the authenticated layout, so it has
// to work for signed-out visitors too. It stays standalone but uses the same
// visual language as the app pages.
const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const canGoBack = typeof window !== 'undefined' && window.history.length > 1;

  return (
    <Box
      component="main"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 6,
        bgcolor: 'background.default'
      }}
    >
      <Paper
        variant="outlined"
        sx={{ width: '100%', maxWidth: 520, p: { xs: 3, sm: 5 }, borderColor: RULE, borderRadius: 2 }}
      >
        <Typography variant="body2" sx={{ color: MUTED, fontVariantNumeric: 'tabular-nums', mb: 1 }}>
          Error 404
        </Typography>
        <Typography
          component="h1"
          sx={{ fontSize: { xs: '1.75rem', md: '2.25rem' }, fontWeight: 700, letterSpacing: '-0.025em', color: INK, lineHeight: 1.15 }}
        >
          Page not found
        </Typography>
        <Typography variant="body1" sx={{ color: MUTED, mt: 1.5, maxWidth: '50ch' }}>
          We couldn't find a page at this address. The link may be out of date, or the page may have moved.
        </Typography>
        {location.pathname && location.pathname !== '/' && (
          <Typography
            variant="body2"
            title={location.pathname}
            sx={{
              mt: 2,
              px: 1.25,
              py: 0.75,
              display: 'inline-block',
              maxWidth: '100%',
              color: INK,
              bgcolor: '#F7F8FA',
              border: `1px solid ${RULE}`,
              borderRadius: 1,
              fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
              fontSize: '0.8125rem',
              overflowWrap: 'anywhere'
            }}
          >
            {location.pathname}
          </Typography>
        )}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 3.5 }}>
          <Button
            component={RouterLink}
            to="/dashboard"
            variant="contained"
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Go to dashboard
          </Button>
          {canGoBack && (
            <Button onClick={() => navigate(-1)} sx={{ textTransform: 'none' }}>
              Go back
            </Button>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default NotFound;
